export const SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
};

export const getNextSortDirection = (currentField, currentDirection, requestedField) => {
  return currentField === requestedField && currentDirection === SORT_DIRECTION.ASC
    ? SORT_DIRECTION.DESC
    : SORT_DIRECTION.ASC;
};

export const sortRows = (rows = [], orderBy, order, comparators = {}) => {
  const comparator = comparators[orderBy];

  if (!comparator) {
    return [...rows];
  }

  const direction = order === SORT_DIRECTION.DESC ? -1 : 1;
  return [...rows].sort((a, b) => direction * comparator(a, b));
};

export const compareText = (a = '', b = '') => {
  return String(a ?? '').localeCompare(String(b ?? ''));
};

export const compareNumber = (a, b) => {
  return Number(a ?? 0) - Number(b ?? 0);
};

export const parseDmyDate = (dateValue = '') => {
  if (typeof dateValue !== 'string' || !dateValue.trim()) {
    return null;
  }

  const [day, month, year] = dateValue.split('-').map(Number);
  if (!day || !month || !year) {
    return null;
  }

  const parsedDate = new Date(year, month - 1, day);
  if (
    Number.isNaN(parsedDate.getTime()) ||
    parsedDate.getDate() !== day ||
    parsedDate.getMonth() !== month - 1 ||
    parsedDate.getFullYear() !== year
  ) {
    return null;
  }

  return parsedDate;
};

export const compareDates = (a, b, emptyDate = new Date(0)) => {
  const dateA = a ? new Date(a) : emptyDate;
  const dateB = b ? new Date(b) : emptyDate;
  return dateA - dateB;
};

export const compareDmyDates = (a, b) => {
  const dateA = parseDmyDate(a);
  const dateB = parseDmyDate(b);

  if (!dateA && !dateB) return 0;
  if (!dateA) return 1;
  if (!dateB) return -1;

  return dateA - dateB;
};

export const includesNormalized = (value, search) => {
  return String(value ?? '').toLowerCase().includes(String(search ?? '').toLowerCase());
};

export const uniqueTruthyValues = (values = [], options = {}) => {
  const { trimStrings = false } = options;

  return [...new Set(
    values
      .map((value) => {
        if (trimStrings && typeof value === 'string') {
          return value.trim();
        }
        return value;
      })
      .filter(Boolean)
  )];
};

export const pluckUniqueTruthyValues = (rows = [], key, options = {}) => {
  return uniqueTruthyValues(rows.map((row) => row?.[key]), options);
};

export const countryLabelOptions = (countryCodes = [], t) => {
  return countryCodes
    .map((countryCode) => ({
      value: countryCode,
      label: t(`countries-${countryCode}`),
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

export const sortCountryCodesByLabel = (countryCodes = [], t) => {
  return [...countryCodes].sort((a, b) =>
    t(`countries-${a}`).localeCompare(t(`countries-${b}`))
  );
};

export const getStoredFilters = (storageKey, defaults) => ({
  ...defaults,
  ...JSON.parse(sessionStorage.getItem(storageKey) || '{}'),
});

export const saveFilters = (storageKey, filters) => {
  sessionStorage.setItem(storageKey, JSON.stringify(filters));
};
